import {fontFamilyRoboto} from '@components/hoc/Theme/Theme.styled';
import styled from 'styled-components';

export const MultiStepSubtitle = styled.p`
  font-family: ${fontFamilyRoboto};
  font-size: 1rem !important;
  color: #717171 !important;
  width: 100%;
  margin: 0.25rem 0;
`;

export const MultiStepTitleWrapper = styled.div`
  width: 100%;
  margin: auto;
`;
